module.exports = __webpack_public_path__ + "fonts/baronsans-extralight-webfont.e09aa346.woff";